import { differenceInHours } from "date-fns"
import { useEffect } from "react"

const DEFAULT_EXPIRATION_HOURS = 24 // Matches auth0 token expiration.

export default function useExpiration({
    expirationInHours = DEFAULT_EXPIRATION_HOURS,
    createdAt,
    onIsExpired,
}: {
    expirationInHours?: number
    createdAt: number | null | undefined
    onIsExpired: () => void
}) {
    useEffect(() => {
        // Skip if threre's no timestamp.
        if (!createdAt) return

        // If it hasn't expired yet, skip.
        if (differenceInHours(new Date(), createdAt) < expirationInHours) return

        // If we made it here, it means the entity has expired.
        onIsExpired()
    }, [createdAt])
}
